module.exports = __webpack_public_path__ + "img/homeIncome3.b4b5392d.png";